module.exports = __webpack_public_path__ + "static/media/email_confirm_bg.04cdfe34.png";